import React, { useContext } from 'react';
import DateSelector from '@/components/DateSelector';
import { LanguageProviderContext } from '@/providers/LanguageProvider';

interface CustomRangePickerProps {
  from: Date;
  to: Date;
  setFrom: (date: Date) => void;
  setTo: (date: Date) => void;
  formatString?: string;
}

const CustomRangePicker = ({ from, to, setFrom, setTo, formatString }: CustomRangePickerProps) => {
  const { translator } = useContext(LanguageProviderContext);
  return (
    <div className="flex items-center gap-2">
      <DateSelector
        selectedDate={from}
        setSelectedDate={setFrom}
        formatString={formatString}
      />
      <span className="text-muted-foreground"> {translator("Global.to")}</span>
      <DateSelector
        selectedDate={to}
        setSelectedDate={setTo}
        formatString={formatString}
      />
    </div>
  );
};

export default CustomRangePicker;